import { Info, CheckCircle, AlertTriangle, XCircle, X } from 'lucide-react'

export default function Alert({ type = 'info', message, onClose }) {
  const styles = {
    info:    'alert-info',
    success: 'alert-success',
    warning: 'alert-warning',
    error:   'alert-error',
  }
  const IconMap = { info: Info, success: CheckCircle, warning: AlertTriangle, error: XCircle }
  const Icon = IconMap[type] || Info

  return (
    <div className={`${styles[type]} flex items-start justify-between gap-2`} role="alert">
      <span className="flex items-start gap-2">
        <Icon size={16} className="flex-shrink-0 mt-0.5" aria-hidden="true" />
        <span>{message}</span>
      </span>
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          className="flex-shrink-0 hover:opacity-70 transition-opacity"
          aria-label="إغلاق"
        >
          <X size={15} />
        </button>
      )}
    </div>
  )
}
